// ISO 3166-1 alpha-2 regions whose numbering plans we accept.
// To support another country, add its region code here.
// PHP (giggsey/libphonenumber-for-php) should use the same list with isValidNumber().

const EU_REGIONS = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]

const PHONE_REGIONS = [
  'AE',
  'SA',
  'QA',
  'KW',
  'BH',
  'OM',
  'GB',
].concat(EU_REGIONS, ['RU', 'KZ', 'UA', 'BY', 'US', 'CA', 'IN', 'PK', 'EG'])

module.exports = { EU_REGIONS, PHONE_REGIONS }
